import { Capacitor } from "@capacitor/core";

// Set via capacitor.config.json → android.appendUserAgent. Lets the live site recognise the shell
// even before/without the Capacitor bridge being injected.
export const UA_MARKER = "SortedAndroidApp";

export const isAndroidShell = () =>
  (typeof navigator !== "undefined" && navigator.userAgent.includes(UA_MARKER)) ||
  (Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android");

export const hasNativeBridge = () => Capacitor.isNativePlatform();
